<template>
  <section class="py-5 container">

    <div class="loading" v-show="isLoading">
        <div class="d-flex justify-content-center mb-3">
            <b-spinner label="Loading..." style="width: 3rem; height: 3rem;" variant="success"></b-spinner>
        </div>
    </div>

    <div v-show="noLoadingError">
        <div class="row">
            <div class="col">
                <div class="text-center">
                    <h1 class="fw-light" v-if="!problemExist">Créer un problème</h1>
                    <h1 class="fw-light" v-if="problemExist">Modifer le problème #{{ publicID }}</h1>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <div class="text-center">

                    <div class="card-text">
                        <form name="editForm">
                            <textarea ref="edit" class="edit" type="text" 
                            v-model="pbText" onfocus="let value = this.value; this.value = null; this.value = value"
                            @paste="onPaste"
                            @dragover.prevent @drop.stop.prevent="dropHandler"
                            @dragover="dragging = true" 
                            @dragleave="dragging = false" 
                            :class="{'edit': true, 'edit hovered': dragging}"></textarea>
                        </form>
                    </div>

                    <div>
                        <p class="lead text-muted text-center">Image : ajouter/changer en glissant-déposant, en collant ou en téléchargeant</p>
                        <div class="outer-div">
                            <div class="inner-div">
                                <b-form-file v-model="file" plain></b-form-file>
                            </div>
                        </div>
                    </div>

                    <div v-show="withPIC">
                        <img :src="picURL"/>
                    </div>

                    <div v-show="withPIC">
                        <button class="btn btn-danger remove-image" @click="removeImage">Supprimer l'image</button>
                    </div>

                </div>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <div class="text-center">
                    <p class="lead text-muted">Sélectionnez les caractéristiques et/ou les typologies</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col">

                <table class="table table-hover">
                <tbody>
                    <tr class="table-warning">
                    <th>Niveau</th>
                    <td>
                        <input class="form-check-input" type="radio" id="cp" value="CP" v-model="checkedLevels">
                        <label class="form-check-label" for="cp">CP</label>
                    </td>
                    <td>
                        <input class="form-check-input" type="radio" id="ce1" value="CE1" v-model="checkedLevels">
                        <label class="form-check-label" for="ce1">CE1</label>
                    </td>
                    <td>
                        <input class="form-check-input" type="radio" id="ce2" value="CE2" v-model="checkedLevels">
                        <label class="form-check-label" for="ce2">CE2</label>
                    </td>
                    <td>
                        <input class="form-check-input" type="radio" id="cm1" value="CM1" v-model="checkedLevels">
                        <label class="form-check-label" for="cm1">CM1</label>
                    </td>
                    <td>
                        <input class="form-check-input" type="radio" id="cm2" value="CM2" v-model="checkedLevels">
                        <label class="form-check-label" for="cm2">CM2</label>
                    </td>
                    </tr>
                    <tr class="table-info">
                    <th>Catégorie</th>
                    <td>
                        <input class="form-check-input" type="radio" id="add" value="ADD" v-model="checkedCategories">
                        <label class="form-check-label" for="add">Additif (+ et -)</label>
                    </td>
                    <td>
                        <input class="form-check-input" type="radio" id="mul" value="MUL" v-model="checkedCategories">
                        <label class="form-check-label" for="mul">Multiplicatif</label>
                    </td>
                    <td>
                        <input class="form-check-input" type="radio" id="div" value="DIV" v-model="checkedCategories">
                        <label class="form-check-label" for="div">Division/partage</label>
                    </td>
                    <td>
                        <input class="form-check-input" type="radio" id="prop" value="PROP" v-model="checkedCategories">
                        <label class="form-check-label" for="prop">Proportionnalité</label>
                    </td>
                    <td>
                        <input class="form-check-input" type="radio" id="num" value="NUM" v-model="checkedCategories">
                        <label class="form-check-label" for="num">Autre</label>
                    </td>
                    </tr>
                    <tr class="table-success">
                    <th>Domaine</th>
                    <td>
                        <input class="form-check-input" type="radio" id="int" value="INT" v-model="checkedDomains">
                        <label class="form-check-label" for="int">Entiers</label>
                    </td>
                    <td>
                        <input class="form-check-input" type="radio" id="dec" value="DEC" v-model="checkedDomains">
                        <label class="form-check-label" for="dec">Décimaux</label>
                    </td>
                    <td>
                        <input class="form-check-input" type="radio" id="frac" value="FRAC" v-model="checkedDomains">
                        <label class="form-check-label" for="frac">Fractions</label>
                    </td>
                    <td>
                        <input class="form-check-input" type="radio" id="geo" value="GEO" v-model="checkedDomains">
                        <label class="form-check-label" for="geo">Géométrie</label>
                    </td>
                    <td>
                        <input class="form-check-input" type="radio" id="logos" value="LOGOS" v-model="checkedDomains">
                        <label class="form-check-label" for="logos">Logique</label>
                    </td>
                    </tr>
                    <tr class="table-danger">
                    <th>Complexité</th>
                    <td>
                        <input class="form-check-input" type="radio" id="one" value="one" v-model="checkedComplexities">
                        <label class="form-check-label" for="one">Une étape</label>
                    </td>
                    <td>
                        <input class="form-check-input" type="radio" id="more" value="more" v-model="checkedComplexities">
                        <label class="form-check-label" for="more">Plus d'une étape</label>
                    </td>
                    <td>
                        <input class="form-check-input" type="radio" id="atypique" value="atypique" v-model="checkedComplexities">
                        <label class="form-check-label" for="atypique">Atypique</label>
                    </td>
                    <td></td>
                    <td></td>
                    </tr>
                </tbody>
            </table>

            <table class="table table-hover">
                <tbody>
                <tr>
                    <th>Additif</th>
                    <td>
                    <input class="form-check-input" type="radio" id="compos" value="compos" v-model="checkedTypoAdd" :disabled="checkedCategories != 'ADD'">
                    <label class="form-check-label" for="compos">Composition</label>
                    </td>
                    <td>
                    <input class="form-check-input" type="radio" id="trans" value="trans" v-model="checkedTypoAdd" :disabled="checkedCategories != 'ADD'">
                    <label class="form-check-label" for="trans">Transformation</label>
                    </td>
                    <td>
                    <input class="form-check-input" type="radio" id="compar" value="compar" v-model="checkedTypoAdd" :disabled="checkedCategories != 'ADD'">
                    <label class="form-check-label" for="compar">Comparaison</label>
                    </td>
                    <td>
                    <input class="form-check-input" type="radio" id="compos-de-trans" value="compos-de-trans" v-model="checkedTypoAdd" :disabled="checkedCategories != 'ADD'">
                    <label class="form-check-label" for="compos-de-trans">Compo. de transfo.</label>
                    </td>
                </tr>
                <tr>
                    <th>Multiplicatif</th>
                    <td>
                    <input class="form-check-input" type="radio" id="n-times" value="n-times" v-model="checkedTypoMul" :disabled="checkedCategories != 'MUL'">
                    <label class="form-check-label" for="n-times">n fois plus/moins</label>
                    </td>
                    <td>
                    <input class="form-check-input" type="radio" id="rect" value="rect" v-model="checkedTypoMul" :disabled="checkedCategories != 'MUL'">
                    <label class="form-check-label" for="rect">Rectangulaire</label>
                    </td>
                    <td>
                    <input class="form-check-input" type="radio" id="cartesian" value="cartesian" v-model="checkedTypoMul" :disabled="checkedCategories != 'MUL'">
                    <label class="form-check-label" for="cartesian">Produit cartésien</label>
                    </td>
                    <td></td>
                </tr>
                <tr>
                    <th>Division</th>
                    <td>
                    <input class="form-check-input" type="radio" id="partition" value="partition" v-model="checkedTypoDiv" :disabled="checkedCategories != 'DIV'">
                    <label class="form-check-label" for="partition">Partition</label>
                    </td>
                    <td>
                    <input class="form-check-input" type="radio" id="quotition" value="quotition" v-model="checkedTypoDiv" :disabled="checkedCategories != 'DIV'">
                    <label class="form-check-label" for="quotition">Quotition</label>
                    </td>
                    <td></td>
                    <td></td>
                </tr>
                </tbody>
            </table>


            </div>
        </div>

        <div class="row">
            <div class="col">
                <div class="text-center">
                    <button class="btn btn-success btn-lg btn-block" v-if="!problemExist" v-on:click="save" :disabled="!isProblemValid">Sauvegarder</button>
                    <button class="btn btn-info btn-lg btn-block" v-if="problemExist" v-on:click="update" :disabled="!isProblemValid">Modifier</button>
                    <button class="btn btn-danger btn-lg btn-block" v-if="problemExist" v-on:click="openDeleteModal">Supprimer</button>
                </div>
            </div>
        </div>

    </div>

    <div v-show="!noLoadingError">
        <div class="row">
            <div class="col">
                <div class="text-center">
                    <h1 class="fw-light" v-if="!problemExist">Ce problème n'existe pas</h1>
                </div>
            </div>
        </div>
    </div>

    <b-modal ref="deleteModal" hide-header>
        <div class="text-center">
            <h3 class="text-danger">En êtes vous sûr ?</h3>
        </div>
        <template #modal-footer>
            <b-button variant="danger" @click="remove()">Supprimer !</b-button>
        </template>
    </b-modal>

    <b-modal id="noPermission" hide-footer hide-header>
        <div class="text-center">
            <h3 class="text-danger">Désolé, vous n'avez pas les droits.</h3>
        </div>
    </b-modal>

  </section>
  
</template>

<script>

    const IMAGE_MIME_REGEX = /^image\/(p?jpeg|gif|png)$/i
    let ID = function () { return Math.random().toString(36).substr(2, 9); }

    export default {
        title () {
            let tabMessage = 'Création d\'un problème'
            let publicID = this.$route.params.publicID
            if(publicID) { tabMessage = `Édition du problème #${publicID}` }
            return tabMessage
        },
        name: 'Edit',
        data() {
        return {
            checkedLevels: null,
            checkedCategories: null,
            checkedDomains: null,
            checkedComplexities: null,

            checkedTypoAdd: null,
            checkedTypoMul: null,
            checkedTypoDiv: null,

            noLoadingError: true,
            tempNameFileList: [],

            withPIC: false,
            picURL: null,
            picNameFile: null,
            dragging: false,
            file: null,
            isLoading: false,

            problemExist: false,
            problem: {},
            pbText: '',
            problems: null,
            publicID: parseInt(this.$route.params.publicID),
            } 
        },
        mounted() {
            this.$refs.edit.focus()
        },
        computed: {
            isProblemValid() {
                return  (this.pbText.length > 0 || this.withPIC) &&
                        this.checkedLevels != null && 
                        this.checkedCategories != null  &&
                        this.checkedDomains != null &&
                        this.checkedComplexities != null &&
                        ((['ADD', 'MUL', 'DIV'].includes(this.checkedCategories) && (this.checkedTypoAdd != null || this.checkedTypoMul != null || this.checkedTypoDiv != null)) || !['ADD', 'MUL', 'DIV'].includes(this.checkedCategories))
            }
        },
        firestore() {
            return {
                problems: this.db.collection('problems'),
            }
        },
        watch: {
            async problems() {
                if(this.publicID) {
                    console.log('switch to update')
                    let data = this.problems.filter(problem => problem.publicID === this.publicID)
                    if (data.length == 1) {
                        this.noLoadingError = true
                        this.problemExist = true
                        this.problem = data[0]

                        // binding form
                        this.pbText = this.problem.text
                        this.checkedLevels = this.problem.level
                        this.checkedCategories = this.problem.category
                        this.checkedDomains = this.problem.domain
                        this.checkedComplexities = this.problem.complexity
                        this.checkedTypoAdd = this.problem.typoAdd
                        this.checkedTypoMul = this.problem.typoMul
                        this.checkedTypoDiv = this.problem.typoDiv

                        if(this.problem.picNameFile) {
                            this.withPIC = true
                            this.picURL = await this.storageRef.child(this.problem.picNameFile).getDownloadURL()
                            this.tempNameFileList.push(this.problem.picNameFile)
                        }
                        this.$nextTick(() => this.$refs.edit.focus())
                    } else {
                        this.noLoadingError = false
                    }
                } else {
                    console.log('switch to create')
                }
            },
            async file() {
                try {
                    if(this.file instanceof Blob) {
                        this.isLoading = true
                        let imageName = 'img_' + ID()
                        let ref = this.storageRef.child(imageName)
                        await ref.put(this.file)
                        this.picNameFile = imageName
                        this.tempNameFileList.push(imageName)
                        this.picURL = await ref.getDownloadURL()
                        this.withPIC = true
                        this.dragging = false
                        this.isLoading = false
                    }
                } catch(error) {
                    console.error(error.code)
                    if(error.code == 'permission-denied' || error.code == 'storage/unauthorized') { this.$bvModal.show('noPermission') }
                }
            },
            checkedCategories() {
                if(this.checkedCategories != 'ADD') { this.checkedTypoAdd = null }
                if(this.checkedCategories != 'MUL') { this.checkedTypoMul = null }
                if(this.checkedCategories != 'DIV') { this.checkedTypoDiv = null }
            }
        },
        methods: {
            async save() {
                
                console.log('saving problem...')
                    this.problem = {
                        text: this.pbText,
                        published: true,
                        createdDate: Date.now(),
                        publicID: Math.max(...[...this.problems].map(pb => pb.publicID), 0) + 1,
                        level: this.checkedLevels,
                        category: this.checkedCategories,
                        domain: this.checkedDomains,
                        complexity: this.checkedComplexities,
                        typoAdd: this.checkedTypoAdd,
                        typoMul: this.checkedTypoMul,
                        typoDiv: this.checkedTypoDiv,
                        picNameFile: this.picNameFile
                    }
                    try {
                        await this.db.collection('problems').add(this.problem)
                        await this.clearStorage(this.problem.picNameFile)
                        this.$router.push({  name: 'Problem', params: { publicID: this.problem.publicID } })
                    } catch(error) {
                        console.error(error.code)
                        if(error.code == 'permission-denied' || error.code == 'storage/unauthorized') { this.$bvModal.show('noPermission') }
                    }
            },
            async update() {
                console.log('updating problem...')
                this.problem.text = this.pbText
                this.problem['mofifiedDate'] = Date.now()
                this.problem.level = this.checkedLevels
                this.problem.category = this.checkedCategories
                this.problem.domain = this.checkedDomains
                this.problem.complexity = this.checkedComplexities
                this.problem.typoAdd = this.checkedTypoAdd
                this.problem.typoMul = this.checkedTypoMul
                this.problem.typoDiv = this.checkedTypoDiv
                this.problem.picNameFile = this.picNameFile

                try {
                    await this.db.collection('problems').doc(this.problem.id).set(this.problem)
                    await  this.clearStorage(this.problem.picNameFile)
                    this.$router.push({ 
                        name: 'Problem',
                        params: {
                            publicID: this.publicID
                            }
                        }) 
                } catch (error) {
                    console.error(error.code)
                    if(error.code == 'permission-denied' || error.code == 'storage/unauthorized') { this.$bvModal.show('noPermission') }
                }
            },
            openDeleteModal() {
                this.$refs.deleteModal.show()
            },
            async remove() {
                console.log('deleting problem...')
                try {
                    await this.db.collection('problems').doc(this.problem.id).delete()
                    this.clearStorage(null)
                    this.$router.push({ name: 'Home' })
                } catch (error) {
                    console.error(error.code)
                    if(error.code == 'permission-denied' || error.code == 'storage/unauthorized') { this.$bvModal.show('noPermission') }
                }
            },
            async dropHandler(event) {
                const file = event.dataTransfer.files[0]
                if(file instanceof Blob) {
                    try {
                        this.isLoading = true
                        let imageName = 'img_' + ID()
                        let ref = this.storageRef.child(imageName)
                        await ref.put(file)
                        this.picNameFile = imageName
                        this.tempNameFileList.push(imageName)
                        this.picURL = await ref.getDownloadURL()
                        this.withPIC = true
                        this.dragging = false
                        this.isLoading = false
                    } catch (error) {
                        console.error(error.code)
                        if(error.code == 'permission-denied' || error.code == 'storage/unauthorized') { this.$bvModal.show('noPermission') }  
                    }
                }
            },
            removeImage() {
                this.picNameFile = null
                this.withPIC = false
                this.picURL = null
                this.file = null
            },
            async onPaste(event) {
                let item = event.clipboardData.items[0];
                if (IMAGE_MIME_REGEX.test(item.type)) {
                    this.isLoading = true
                    let file = item.getAsFile()
                    let reader = new FileReader()
                    reader.onload = e => {
                        var img = new Image
                        img.onload = () => {
                            var canvas = document.createElement("canvas")
                            canvas.width = img.width;
                            canvas.height = img.height;
                            canvas.style.width = img.width/2
                            canvas.style.height = img.height/2
                            var ctx = canvas.getContext("2d")
                            ctx.drawImage(img,0,0)
                            ctx.scale(2,2)
                            canvas.toBlob(async blob =>  {
                                try {
                                    let imageName = 'img_' + ID()
                                    let ref = this.storageRef.child(imageName)
                                    await ref.put(blob)
                                    this.picNameFile = imageName
                                    this.tempNameFileList.push(imageName)
                                    this.picURL = await ref.getDownloadURL()
                                    this.withPIC = true
                                    this.dragging = false
                                    this.isLoading = false
                                } catch (error) {
                                    console.error(error.code)
                                    if(error.code == 'permission-denied' || error.code == 'storage/unauthorized') { this.$bvModal.show('noPermission') }  
                                }
                            })
                        }
                        img.src = e.target.result
                    }
                    reader.readAsDataURL(file)
                }
            },
            clearStorage(currentPicNameFile) {
                let numberOfFileRemoved = 0
                this.tempNameFileList.forEach(imageName => { 
                    if(imageName != currentPicNameFile) {
                        try {
                            this.storageRef.child(imageName).delete()
                            numberOfFileRemoved += 1
                        } catch (error) {
                            console.error(error.code)
                            if(error.code == 'permission-denied' || error.code == 'storage/unauthorized') { this.$bvModal.show('noPermission') }  
                        }
                    }
                })
                console.log(`clearStorage : ${numberOfFileRemoved} files removed`)
            }
        }
    }
</script>

<style scoped>
    .edit {
        resize: none;
        border: solid 2px;
        border-color: #198754;
        height: calc(50vh);
        width: 100%;
        text-align: center;
        outline: none;
        white-space: pre-wrap;
        font-size: xx-large;
        overflow:hidden;
        padding: 16px 16px 16px 16px;
        margin: 16px 16px 16px 16px;
    }
    .hovered {
        background-color: #C6E2FF;
    }
    img {
        max-width: 200px;
    }
    .remove-image {
        margin-top: 1rem;
        margin-bottom: 16px;
    }
    .outer-div {
        padding: 0px;
        text-align: center;
    }
    .inner-div {
        display: inline-block;
        padding: 8px 0px 16px 0px;
    }
    .loading {
        position: fixed;
        top: 8px; right: 0;
        bottom: 0; left: 0;
        background: #fff;
    }
</style>